import "./index.css";
import { jsxs, jsx } from 'react/jsx-runtime';
import { Container } from '@design-system/container';
import { HeadingBlock } from '@design-system/heading-block';
import { Section } from '@design-system/section';
import classNames from 'classnames';
import { forwardRef } from 'react';
const PageBlock = forwardRef((_ref, ref) => {
  let {
    className,
    element = 'div',
    mode = 'default',
    maxWidth = 'full-width',
    heading,
    children,
    disableGutters,
    id,
    componentUid
  } = _ref;
  return jsxs(Section, Object.assign({
    ref: ref,
    mode: mode,
    element: element,
    className: classNames('cds-page-block', className),
    id: id,
    "data-component-uid": componentUid
  }, {
    children: [heading && jsx(Container, Object.assign({
      maxWidth: maxWidth
    }, {
      children: jsx(HeadingBlock, Object.assign({
        className: "cds-page-block__heading"
      }, heading))
    })), jsx(Container, Object.assign({
      disableGutters: disableGutters,
      className: "cds-page-block__content",
      maxWidth: maxWidth
    }, {
      children: children
    }))]
  }));
});
export { PageBlock };